#import "../../../../common/graphql/EntityDocumentsFields.graphql"
query TravelPlanDetails($id: UUID!) {
  travelAuthorization(id: $id) {
    id
    _rowTimestamp
    comment
    businessUnit {
      name
    }
    department {
      name
    }
    supplier {
      _fullName
    }
    bookingFee
    travelAuthorizationDate
    currency {
      isoCode
    }
    controlTotalAmount
    tripPurpose
    statusType {
      approvalState
    }
    _accountingStampDate
    _accountingStampTransactionReference
    _accountingStampUserName
    _isAccountingEntryStampedComplete
    _isTransactionCancelled
    stampedEntityDocumentId
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _rowTimestamp
        _createdDate
        createdByUser
      }
    }
    travelAuthorizationHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
      totalCount
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
    trips {
      nodes {
        tripLocator
        travelerReferenceName
        accountReference
        airfareAmount
        accommodationAmount
        vehicleRentalAmount
        transportationAmount
        trainAmount
        incidentalAmount
        controlTotalAmount
      }
    }
  }
}
